import React from 'react';

import LinkLang from '../LinkLang';

const LinkWrap = ({ to, isExternal, className, state, children }) => {
  const output = isExternal ? (
    <a
      href={to}
      className={className}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  ) : (
    <LinkLang to={to} className={className} state={state}>
      {children}
    </LinkLang>
  );
  return output;
};

export default LinkWrap;
